import "./Home.css";
import React, { useState } from "react";
import SideBar from "../../Components/Organisms/Bars/SideBar/SideBar";
import NavBar from "../../Components/Organisms/Bars/NavBar/NavBar";
import { Link, Route, Routes } from "react-router-dom";
import CloseIcon from "@mui/icons-material/Close";
import useLogout from "../../Hooks/useLogout";
import { logoutURL } from "../../Hooks/URL";
import PrimaryButton from "../../Components/Atoms/Buttons/Primary/PrimaryButton";
import ProfilePage from "../../Pages/Profile/ProfilePage";
import AddTeamPage from "../../Pages/Teams/AddTeamPage";
import TeamsPage from "../../Pages/Teams/TeamsPage";
import MembersPage from "../../Pages/Members/MembersPage";
import AddMemberPage from "../../Pages/Members/AddMemberPage";
import CoachesPage from "../../Pages/Coaches/CoachesPage";
import AddCoachPage from "../../Pages/Coaches/AddCoachPage";
import TeamProfilePage from "../../Pages/Teams/TeamProfilePage";
import TransactionsPage from "../../Pages/Transactions/TransactionsPage";
import TransactionResultPage from "../../Pages/Transactions/TransactionResultPage";
import MissionPage from "../../Pages/Missions/MissionPage";

function Home() {
  const [showMenu, setShowMenu] = useState(false);
  const [goSave, setGoSave] = useState(false);
  function handleShowMenu() {
    setShowMenu(!showMenu);
  }
  const { saveState } = useLogout({
    url: logoutURL,
    goSave,
    setGoSave,
  });

  return (
    <div className="Home">
      <NavBar showMenu={showMenu} setShowMenu={setShowMenu} />
      <div className="container">
        <div className={`sidebar ${showMenu ? "sidebarOpen" : "sidebarClose"}`}>
          <span
            className={"closeIcon mobile " + (showMenu ? "" : "hidden")}
            onClick={() => handleShowMenu()}
            style={{
              width: "100%",
              display: "flex",
              justifyContent: "space-between",
              padding: "0 20px",
            }}
          >
            <PrimaryButton
              classBtn={"center mobile"}
              text={"Logout"}
              click={() => {
                setGoSave(true);
                // setShowMenu(false);
              }}
              style={{
                textTransform: "capitalize",
                width: "100px",
                borderRadius: "5px",
                color: "#068399",
                backgroundColor: "white",
                height: "45px",
              }}
            />
            <CloseIcon
              sx={{
                fontSize: 30,
                marginBottom: 2,
                marginLeft: 2,
                cursor: "pointer",
              }}
            />
          </span>
          <SideBar setShowMenu={setShowMenu} />
        </div>
        <div className="main">
          <Routes>
            <Route path="/" element={<ProfilePage />} />
            <Route path="/mission/:id" element={<MissionPage />} />
            {/* <Route path="/mission2" element={<Mission2Page />} />
            <Route path="/mission3" element={<Mission3Page />} /> */}
          </Routes>
        </div>
      </div>
    </div>
  );
}

export default Home;
